import React, { useState } from "react";
import { LinkProps } from "react-router-dom";
import { useActivityPanel } from "../../hooks/useActivityPanel";
import ActivityLinkContextMenu from "./ContextMenu";

interface ActivityLinkProps extends Omit<LinkProps, "to"> {
  className?: string;
  customerNo: number;
  workItemNo: number;
  to?: string;
}

const ActivityLink: React.FC<ActivityLinkProps> = ({
  className,
  children,
  customerNo,
  workItemNo,
  to,
  ...rest
}) => {
  const { openActivity } = useActivityPanel();
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    data: { customerNo: number; workItemNo: number };
  } | null>(null);

  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      data: {
        customerNo: customerNo,
        workItemNo: workItemNo,
      },
    });
  };

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    openActivity(workItemNo);
  };

  return (
    <>
      <a
        className={`activity-link ${className || ""}`}
        href="#"
        onClick={handleClick}
        onContextMenu={handleContextMenu}
        style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
        {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {children}
      </a>
      <ActivityLinkContextMenu
        contextMenu={contextMenu}
        onClose={handleCloseContextMenu}
      />
    </>
  );
};

export default ActivityLink;
